import { render } from "./InvoiceReview.vue?vue&type=template&id=45c13846"
import script from "./InvoiceReview.vue?vue&type=script&lang=js"
export * from "./InvoiceReview.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dharmik/www/pfizer-invoicing-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__